export const initialContext: CartHandoffContext = {
  orderToken: undefined,
  conflicts: [],
  ignoreConflicts: false,
};

// ─── Types ───────────────────────────────────────────────────────────────────

export type CartHandoffContext = Readonly<{
  orderToken: string | undefined;
  conflicts: string[];
  ignoreConflicts: boolean;
}>;
